module.exports = __webpack_public_path__ + "static/img/state7.fba91a3c.png";